<template>

  <div v-if="!!workOrder">
    <div class="row">
      <div class="col-sm-3"><h1>{{ workOrder.orderNumber }}</h1></div>
      <div class="col-sm-3 d-none d-lg-block"><h3>Servisni nalog</h3></div>
      <div class="col-sm-3" :class="{ 'offset-md-3': !workOrder.duplicatedFromServiceOrder }">
        <h2>
          <OrderBadge :workOrder="workOrder" />
        </h2>
      </div>
    </div>

    <div class="row mb-3 mt-3">
    <div class="col-md-8">

      <SelectCustomerEntity
        required
        :customerID="workOrder.customerID"
        :facilityID="workOrder.facilityID"
        :canChange="false"
        :canChangeCustomer="false"
      />

      <div class="row mb-3">
        <label class="col-form-label col-sm-4">Prijava</label>
        <div class="col-sm-8">
          <input class="form-control" type="datetime-local" v-model="workOrder.dateSubmittedForInput" :disabled="true">
        </div>
      </div>
      <div class="row mb-3">
        <label class="col-form-label col-sm-4">Delavec</label>
        <div class="col-sm-8">
          <SelectEntity apiEntity="DropDown/Workers" v-model="workOrder.ownerID" :canChange="false" />
        </div>
      </div>
      <div class="row mb-3">
          <label class="col-form-label col-sm-4">Zadeva *</label>
          <div class="col-sm-8">
            <input class="form-control" type="text" v-model="workOrder.subject" :disabled="true" />
          </div>
      </div>
      <div class="row mb-3">
        <label class="col-form-label col-sm-4">Opis napake</label>
        <div class="col-sm-8">
          <textarea class="form-control" v-model="workOrder.issueDescription" :disabled="true" rows="15"></textarea>
        </div>
      </div>
      <div class="row mb-3">
        <label class="col-form-label col-sm-4">
          Opis del<br>
        </label>
        <div class="col-sm-8">
          <textarea class="form-control" v-model="workOrder.workDescription" :disabled="true" rows="15"></textarea>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-form-label col-3 col-sm-4">Prioriteta *</div>
        <div class="col-9 col-sm-8">
          <IntegerRadioGroup v-model="workOrder.priority" :canChange="false" :numberOfValues=3 namePrefix="priority" :valueNames="['1','2', '3 (najnižja)']" />
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card mb-3">
        <div class="card-body">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="is-special"
              v-model="workOrder.isSpecial"
              :disabled="true">
            <label class="form-check-label" for="is-special">Ima posebnosti</label>
          </div>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="has-warranty"
              v-model="workOrder.hasWarranty"
              :disabled="true">
            <label class="form-check-label" for="has-warranty">Garancija</label>
          </div>
        </div>
      </div>

      <div class="card mb-3" v-if="!isNew && (!!devices?.find(d => d.isLeakageTest) || workOrder.hasLeakageCheckForms)">
        <div class="card-body">
          <h5 class="card-title d-none d-lg-block">Uhajanje</h5>

          <p class="card-text mt-3" v-show="workOrder?.leakageCheckForms?.length > 0">
            {{ workOrder.leakageCheckForms.length }} preskusi tesnosti od {{ devices?.filter(d => d.isLeakageTest).length }} naprav:
          </p>
          <p class="card-text mt-3" v-show="workOrder?.leakageCheckForms?.length === 0">
            Št. naprav: {{ devices?.filter(d => d.isLeakageTest).length }}.
          </p>
          <ul>
            <li v-for="f in workOrder.leakageCheckForms">
              <a :href="$AZURE_URI + '/Generated/Leakage/' + workOrder.id + '?leakageFormId=' + f.id">{{ f.device?.label }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="card mb-3" v-if="workOrder.haschecklists">
        <div class="card-body">
          <h5 class="card-title d-none d-lg-block">Kontrolni listi termometrov</h5>
          <ul>
            <li v-for="cr in workOrder.checklists" role="button" class="text-decoration-underline">
              <a v-if="workOrder.ownerID !== $EMPTY_GUID" :href="$AZURE_URI + '/Generated/CalibrationReport/' + workOrder.id + '?deviceId=' + cr.device.id" target="_blank">{{ cr.device.label }} - {{ cr.device.deviceNumber }}</a>
              <span v-else>{{ cr.device.label }} - {{ cr.device.deviceNumber }} (izberi delavca za podpis)</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="h-100 p-4 bg-light border rounded-3 mb-3" v-if="!workOrder.isNew">
      <div class="row">
        <h4 class="col-2">Priloge</h4>
      </div>
      <div class="row">
        <div class="col">
          <Attachments
            :attachments="attachments"
          />
        </div>
      </div>
    </div>

  </div>

  <div class="row mb-5">
    <div class="col-10 text-end">
      <button class="btn btn-outline-secondary me-3 mb-2" type="button" @click="$router.push({ name: 'Service' })">Prekliči</button>
    </div>
  </div>

</div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorkOrder } from "../composition-api/useWorkOrder"

defineOptions({ name: "ServiceOrderCustomer" })


// isNew and devices are used by the template (the leakage-test card) - they were missing from
// this destructuring, so that card read them as undefined
const { isNew, workOrder, attachments, devices } = useWorkOrder("Service")
</script>
